import useParticipants from "../../hooks/useParticipants";
import Participant from "./Participant";

const ParticipantList = () => {
  const participants = useParticipants();
  return participants.map((participant) => (
    <Participant participant={participant} key={participant.identity} />
  ));
};

export default ParticipantList;
